/* Wheel prize guard (job/wof-gift-guard, 2026-10-04) — see snippets/aly-wof-guard.liquid.
   Cart lines with a priced wheel prize carry [data-aly-wof-note data-variant]. This script sums the other paid
   lines from /cart.js; while they are below £40 (converted with Shopify.currency.rate) it shows [data-aly-wof-block]
   and hides the checkout / express buttons next to it (.aly-wof-locked), and fills the line notes. */
(function () {
  'use strict';
  const MIN_GBP_CENTS = 4000;
  const MINE = 'X-Aly-Wof';
  const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  const cur = () => (window.Shopify && Shopify.currency) || {};
  const minCents = () => Math.ceil(MIN_GBP_CENTS * (parseFloat(cur().rate) || 1));
  const fmt = c => {
    try { return new Intl.NumberFormat('en-GB', { style: 'currency', currency: cur().active || 'GBP' }).format(c / 100); }
    catch (e) { return '£' + (c / 100).toFixed(2); }
  };
  const setText = (el, t) => { if (el && el.textContent !== t) el.textContent = t; };
  let cart = null, dirty = true, lastSig = '', busy = false;

  function apply(left) {
    const locked = left !== null && left > 0;
    document.querySelectorAll('[data-aly-wof-block]').forEach(b => {
      const box = b.parentElement;
      if (box && box.classList.contains('aly-wof-locked') !== locked) box.classList.toggle('aly-wof-locked', locked);
      if (b.hidden === locked) b.hidden = !locked;
      if (locked) setText(b.querySelector('[data-aly-wof-left]'), fmt(left));
    });
    document.querySelectorAll('[data-aly-wof-note]').forEach(n => {
      setText(n.querySelector('[data-aly-wof-min]'), fmt(minCents()));
      setText(n.querySelector('[data-aly-wof-status]'),
        locked ? ' Add ' + fmt(left) + ' more to unlock it.' : ' Enter your wheel code at checkout.');
    });
  }

  async function run() {
    const notes = [...document.querySelectorAll('[data-aly-wof-note]')];
    const sig = notes.map(n => n.getAttribute('data-variant')).join(',');
    if (!notes.length) { if (lastSig !== '') { lastSig = ''; apply(null); } else if (document.querySelector('.aly-wof-locked')) apply(null); return; }
    if (busy) return;
    if (sig !== lastSig) dirty = true;
    lastSig = sig;
    if (dirty || !cart) {
      busy = true;
      try { cart = await fetch(root + 'cart.js', { credentials: 'same-origin', headers: { [MINE]: '1' } }).then(r => r.json()); dirty = false; }
      catch (e) { cart = null; }
      finally { busy = false; }
    }
    if (!cart) return;
    const wof = new Set(notes.map(n => String(n.getAttribute('data-variant'))));
    const hasWof = cart.items.some(i => wof.has(String(i.variant_id)) && i.final_line_price > 0);
    const others = cart.items.reduce((s, i) => s + (wof.has(String(i.variant_id)) ? 0 : i.final_line_price), 0);
    apply(hasWof ? minCents() - others : null);
  }

  let t = 0;
  const schedule = () => { clearTimeout(t); t = setTimeout(run, 120); };
  // any cart write by the theme or apps → re-read the cart
  const _fetch = window.fetch;
  window.fetch = function (input, init) {
    const url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
    const p = _fetch.apply(this, arguments);
    if (!(init && init.headers && init.headers[MINE]) && /\/cart\/(add|change|update|clear)(\.js|\.json)?/.test(url)) {
      p.then(() => { dirty = true; schedule(); }, () => {});
    }
    return p;
  };
  new MutationObserver(schedule).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
})();
